/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Error({
  children,
  viewPath = "/App/ChooseUser/Users/Error"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="Error.Text"
  data-view-path={viewPath}
 className="views-text"
>
We had an error
</span>
{children}
</React.Fragment>)
}